export const GET_SUBMISSION_LIST_REQUEST = 'Submissions/GET_SUBMISSION_LIST_REQUEST';
export const GET_SUBMISSION_LIST_SUCCESS = 'Submissions/GET_SUBMISSION_LIST_SUCCESS';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
